import { render, staticRenderFns } from "./OrderDocumentCustomTable.vue?vue&type=template&id=5edf1a82&scoped=true&"
import script from "./OrderDocumentCustomTable.vue?vue&type=script&lang=js&"
export * from "./OrderDocumentCustomTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocumentCustomTable.vue?vue&type=style&index=0&id=5edf1a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf1a82",
  null
  
)

export default component.exports